import PopularMovies from "./PopularMovies";

export default PopularMovies;
